export default __webpack_public_path__ + "static/media/delete-circle.f5ed6f9e.svg";